import * as React from 'react';

import styles from './settings-content-wrapper.module.css';

type Props = {
    children: React.ReactNode;
};

export function SettingsContentWrapper(props: Props) {
    return (
        <div className={styles['settings-page-wrapper']}>
            <div className={styles['inner-content']}>{props.children}</div>
        </div>
    );
}
